let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g6jVO")).then(() => parcelRequire('b5vXe'));